export default __webpack_public_path__ + "static/media/imagotipo-blue-h.48dddaa3.svg";